import React from "react";
import styles from "./tata.module.scss";
import qrcode from "../../../../images/qr.png";
import regBarcode from "../../../../images/registartinbarcode.png";
import signature from "../../../../images/Picture5.jpg";
import { MdOutlineEmail } from "react-icons/md";
import { AiOutlineGlobal } from "react-icons/ai";
import Image from "react-bootstrap/Image";

const TataReport = ({
  clinic,
  address,
  qrCode,
  item,
  referrer,
  selectedItem,
  forPrint = false,
  reportType = "report", // "report", "invoice", or "receipt"
}) => {
  const safeImageProps = {
    crossOrigin: forPrint ? "anonymous" : undefined,
  };
  console.log(selectedItem);
  const invoiceHeaderLeft = () => (
    <div className={styles.page}>
      <div className={styles["header"]}>
        <div className={styles["logo"]} style={{ width: "72%" }}>
          <Image
            src={clinic?.hospitalInfo?.pdfHeader}
            alt="logo"
            {...safeImageProps}
          />
          <div>
            <p className={styles["bold"]}>{clinic?.clinicName}</p>
            <p>{address}</p>
          </div>
          <div className={styles["info-links"]}>
            <p>
              <AiOutlineGlobal />{" "}
              <span>{clinic?.hospitalInfo?.web_address}</span>
            </p>
            <p>
              <MdOutlineEmail />
              <span>{clinic?.clinicEmail}</span>
            </p>
            <p>CIN: U74140DL2015PTC279229</p>
          </div>
          <p>{clinic?.hospitalInfo?.iso_certificate}</p>
        </div>
        <div className={styles["rightside"]}>
          <div>
            <Image
              src={clinic.hospitalInfo?.ISOLogo}
              alt="iso"
              {...safeImageProps}
            />
          </div>
          <div className={styles["trust-badge"]}>
            <p className={styles["trusted"]}>Most Trusted Brand</p>
            <p className={styles["lakhs"]}>40 lakhs+</p>
            <p>satisfied customers</p>
            <p className={styles["crore"]}>1 crore+</p>
            <p>lab tests booked</p>
          </div>
        </div>
      </div>
    </div>
  );

  const invoiceHeaderCenter = () => (
    <div className={styles["headerCenter"]}>
      <div className={styles["header"]} style={{ alignItems: "center" }}>
        <div className={styles["logo"]} style={{ width: "30%" }}>
          <div>
            <p className={styles["bold"]} style={{ fontSize: "1rem" }}>
              {clinic?.clinicName}
            </p>
            <p>{address}</p>
          </div>
          <div className={styles["info-links"]}>
            <p>
              <AiOutlineGlobal />{" "}
              <span>{clinic?.hospitalInfo?.web_address}</span>
            </p>
          </div>
          <div className={styles["info-links"]}>
            <p>
              <MdOutlineEmail />
              <span>{clinic?.clinicEmail}</span>
            </p>
          </div>
          <div className={styles["info-links"]}>
            <p>
              CIN :<span>U74140DL2015PTC279229</span>
            </p>
          </div>
          <p>{clinic?.hospitalInfo?.iso_certificate}</p>
        </div>
        <Image
          src={clinic?.hospitalInfo?.pdfHeader}
          alt="logo"
          style={{ width: "22rem", height: "4.5rem" }}
          {...safeImageProps}
        />
        <div className={styles["rightside"]}>
          {clinic?.hospitalInfo?.displayISOlogo && (
            <div>
              <Image
                src={clinic.hospitalInfo?.ISOLogo}
                alt="iso"
                {...safeImageProps}
              />
            </div>
          )}
          <div className={styles["trust-badge"]}>
            <p className={styles["trusted"]}>Most Trusted Brand</p>
            <p className={styles["lakhs"]}>40 lakhs+</p>
            <p>satisfied customers</p>
            <p className={styles["crore"]}>1 crore+</p>
            <p>lab tests booked</p>
          </div>
        </div>
      </div>
    </div>
  );

  const invoiceHeaderRight = () => (
    <div className={styles["header"]}>
      <div
        className={styles["rightside"]}
        style={{ gap: "2rem", width: "57%" }}
      >
        <div>
          <Image src={clinic.hospitalInfo?.ISOLogo} alt="iso" />
        </div>
        <div className={styles["trust-badge"]}>
          <p className={styles["trusted"]}>Most Trusted Brand</p>
          <p className={styles["lakhs"]}>40 lakhs+</p>
          <p>satisfied customers</p>
          <p className={styles["crore"]}>1 crore+</p>
          <p>lab tests booked</p>
        </div>
      </div>
      <div className={styles["logo"]} style={{ width: "72%" }}>
        <Image src={clinic?.hospitalInfo?.pdfHeader} alt="logo" />
        <div>
          <p className={styles["bold"]}>{clinic?.clinicName}</p>
          <p>{address}</p>
        </div>
        <div className={styles["info-links"]} style={{ display: "block" }}>
          <p>
            <AiOutlineGlobal /> <span>{clinic?.hospitalInfo?.web_address}</span>
          </p>
          <p>
            <MdOutlineEmail />
            <span>{clinic?.clinicEmail}</span>
          </p>
          <p>CIN: U74140DL2015PTC279229</p>
        </div>
        <p>{clinic?.hospitalInfo?.iso_certificate}</p>
      </div>
    </div>
  );
  return (
    <>
      <div className={styles["page"]}>
        {clinic?.hospitalInfo?.headerAlignment === "left" &&
          invoiceHeaderLeft()}
        {clinic?.hospitalInfo?.headerAlignment === "right" &&
          invoiceHeaderRight()}
        {clinic?.hospitalInfo?.headerAlignment === "center" &&
          invoiceHeaderCenter()}
        <div className={styles["waterMark"]}>
          <img
            src={clinic?.hospitalInfo?.waterMark}
            alt="watermark"
            {...safeImageProps}
          />
        </div>
        <div className={styles["middleSection"]}>
          <div className={styles["barcodeSection"]}>
            <p>PO No :PO4150218596-451</p>
            <img src={regBarcode} alt="" {...safeImageProps} />
          </div>
          <div className={styles["headerDetails"]}>
            <div className={styles["headerDetailsLeft"]}>
              <p>
                <span className={styles["bold"]}>Name</span>:{" "}
                {selectedItem?.patientId?.userId?.name ||
                  selectedItem?.patientName ||
                  "N/A"}
              </p>
              {/* <p>
                <span className={styles["bold"]}>Age/Gender</span>:{" "}
                {selectedItem?.age || item?.age || selectedItem?.patientId?.age || "N/A"} / {selectedItem?.gender || item?.gender || selectedItem?.patientId?.gender || "N/A"}
              </p> */}
              <p>
                <span className={styles["bold"]}>Patient ID</span>:{" "}
                {selectedItem?.patientId?.UHID ||
                  selectedItem?.patientId?._id ||
                  "N/A"}
              </p>
              {(reportType === "invoice" || reportType === "receipt") && (
                <>
                  <p>
                    <span className={styles["bold"]}>Email</span>:{" "}
                    {selectedItem?.patientId?.userId?.email || "N/A"}
                  </p>
                  <p>
                    <span className={styles["bold"]}>Phone</span>:{" "}
                    {selectedItem?.patientId?.userId?.phone || "N/A"}
                  </p>
                  <p>
                    <span className={styles["bold"]}>Date</span> :{" "}
                    {selectedItem?.appDate
                      ? new Date(selectedItem.appDate).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          },
                        )
                      : selectedItem?.createdAt
                        ? new Date(selectedItem.createdAt).toLocaleDateString(
                            "en-GB",
                          )
                        : "N/A"}
                  </p>
                </>
              )}
              {/* {reportType !== "invoice" && reportType !== "receipt" && (
                <p>
                  <span className={styles["bold"]}>Referred By</span>:{" "}
                  {referrer?.name || "N/A"}
                </p>
              )} */}
            </div>

            {/* {reportType !== "invoice" && reportType !== "receipt" && (
              <div className={styles["headerDetailsRight"]}>
                <p>
                  <span className={styles["bold"]}>Client Name</span>: TATA 1MG
                  KOLKATA
                </p>
                <p>
                  <span className={styles["bold"]}>Registration Date</span> :{" "}
                  {selectedItem?.createdDt
                    ? new Date(selectedItem.createdDt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        }
                      )
                    : "N/AA"}
                </p>
                <p>
                  <span className={styles["bold"]}>Collection Date</span> :{" "}
                  {selectedItem?.createdDt
                    ? new Date(selectedItem.createdDt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        }
                      )
                    : "N/AA"}
                </p>
                <p>
                  <span className={styles["bold"]}>Sample Receive Date</span> :{" "}
                  {selectedItem?.updatedDt
                    ? new Date(selectedItem.updatedDt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        }
                      )
                    : "N/AA"}
                </p>
                <p>
                  <span className={styles["bold"]}>Report Date</span> :{" "}
                  {selectedItem?.updatedDt
                    ? new Date(selectedItem.updatedDt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        }
                      )
                    : "N/AA"}
                </p>
              </div>
            )} */}
          </div>
        </div>

        <div className={styles["tableDiv"]}>
          {(() => {
            const data =
              selectedItem && Object.keys(selectedItem).length
                ? selectedItem
                : item || {};
            const hasInvoiceItems =
              (data.tests && data.tests.length) ||
              (data.profiles && data.profiles.length) ||
              (data.dentalServices && data.dentalServices.length) ||
              (data.hairServices && data.hairServices.length) ||
              (data.skinServices && data.skinServices.length) ||
              (data.generalServices && data.generalServices.length) ||
              (data.radioServices && data.radioServices.length) ||
              (data.healthScreeningDetails &&
                data.healthScreeningDetails.length) ||
              (data.healthPackageDetails && data.healthPackageDetails.length);

            const getTaxFromItem = (it) => {
              if (!it || typeof it !== "object") return 0;
              if (typeof it?.tax === "number") return it.tax;
              for (const key of Object.keys(it || {})) {
                if (
                  it[key] &&
                  typeof it[key] === "object" &&
                  "tax" in it[key]
                ) {
                  return Number(it[key].tax) || 0;
                }
              }
              return 0;
            };

            if (hasInvoiceItems) {
              const rows = [];
              let slNo = 1;
              const addRow = (name, rate, tax) => {
                const r = Number(rate || 0);
                const t = Number(tax || 0);
                const sgst = t / 2;
                const cgst = t / 2;
                const total = r + (r * t) / 100;
                rows.push(
                  <tr key={`row-${slNo}`}>
                    <td className="center">{slNo++}</td>
                    <td className="left">{name}</td>
                    <td className="right">{r.toFixed(2)}</td>
                    <td className="center">{t.toFixed(2)}%</td>
                    <td className="center">{sgst.toFixed(2)}%</td>
                    <td className="center">{cgst.toFixed(2)}%</td>
                    <td className="right">{total.toFixed(2)}</td>
                  </tr>,
                );
              };

              const idMapping = {
                tests: { id: "testId", nameKey: "testName" },
                profiles: { id: "profileId", nameKey: "profileName" },
                dentalServices: { id: "dentalId", nameKey: "serviceName" },
                hairServices: { id: "hairId", nameKey: "serviceName" },
                skinServices: { id: "skinId", nameKey: "serviceName" },
                generalServices: { id: "generalId", nameKey: "serviceName" },
              };

              [
                "tests",
                "profiles",
                "dentalServices",
                "hairServices",
                "skinServices",
                "generalServices",
              ].forEach((key) => {
                const mapping = idMapping[key];
                if (Array.isArray(data?.[key])) {
                  data[key].forEach((it) => {
                    const serviceName =
                      it?.[mapping?.id]?.[mapping?.nameKey] ||
                      it?.serviceName ||
                      "N/A";
                    const tax = it?.[mapping?.id]?.tax || it?.tax || 0;
                    addRow(serviceName, it?.price || it?.totalAmount || 0, tax);
                  });
                }
              });

              if (Array.isArray(data?.physiotherapyService)) {
                data.physiotherapyService.forEach((it) => {
                  const serviceName =
                    it?.physioId?.serviceDetailName ||
                    it?.serviceName ||
                    "Physiotherapy";
                  const tax = it?.physioId?.tax || it?.tax || 0;
                  addRow(serviceName, it?.price || 0, tax);
                });
              }

              if (Array.isArray(data?.radioServices)) {
                data.radioServices.forEach((it) => {
                  const serviceName =
                    it?.radiologyServiceInfo?.serviceName || "Radiology";
                  if (Array.isArray(it?.radiologyServiceInfo?.serviceDetails)) {
                    it.radiologyServiceInfo.serviceDetails.forEach((detail) => {
                      const detailName =
                        detail?.radioId?.serviceDetailsName ||
                        detail?.serviceName ||
                        "Service";
                      const tax = detail?.radioId?.tax || detail?.tax || 0;
                      addRow(
                        `${serviceName} - ${detailName}`,
                        detail?.price || 0,
                        tax,
                      );
                    });
                  }
                });
              }

              if (Array.isArray(data?.healthScreeningDetails)) {
                data.healthScreeningDetails.forEach((it) => {
                  const serviceName =
                    it?.healthScreeningName ||
                    it?.serviceName ||
                    "Health Screening";
                  const tax = it?.tax || 0;
                  addRow(serviceName, it?.healthScreeningAmount || 0, tax);
                });
              }

              if (Array.isArray(data?.healthPackageDetails)) {
                data.healthPackageDetails.forEach((it) => {
                  const serviceName =
                    it?.healthPackageName ||
                    it?.serviceName ||
                    "Health Package";
                  const tax = it?.tax || 0;
                  addRow(serviceName, it?.healthPackageAmount || 0, tax);
                });
              }

              let computedTotal = 0;
              const computeAdd = (rate, tax) => {
                const r = Number(rate || 0);
                const t = Number(tax || 0);
                computedTotal += r + (r * t) / 100;
              };

              [
                "tests",
                "profiles",
                "dentalServices",
                "hairServices",
                "skinServices",
                "generalServices",
              ].forEach((key) =>
                (data?.[key] || []).forEach((it) =>
                  computeAdd(
                    it?.price || it?.totalAmount || 0,
                    getTaxFromItem(it),
                  ),
                ),
              );
              (data?.physiotherapyService || []).forEach((it) =>
                computeAdd(it?.price || 0, it?.physioId?.tax || 0),
              );
              (data?.radioServices || []).forEach((it) =>
                (it?.radiologyServiceInfo?.serviceDetails || []).forEach((d) =>
                  computeAdd(d?.price || 0, getTaxFromItem(d)),
                ),
              );
              (data?.healthScreeningDetails || []).forEach((it) =>
                computeAdd(it?.healthScreeningAmount || 0, getTaxFromItem(it)),
              );
              (data?.healthPackageDetails || []).forEach((it) =>
                computeAdd(it?.healthPackageAmount || 0, getTaxFromItem(it)),
              );

              const billedBy =
                clinic?.clinicName || clinic?.hospitalInfo?.web_address || "";
              const paidFromReceipt =
                item?.receiptId?.paymentDetails?.[0]?.paidAmount;
              const dueFromReceipt =
                item?.receiptId?.paymentDetails?.[0]?.dueAmount;
              const paidAmount =
                typeof data?.paidAmount === "number"
                  ? data.paidAmount
                  : typeof item?.paidAmount === "number"
                    ? item.paidAmount
                    : typeof paidFromReceipt === "number"
                      ? paidFromReceipt
                      : 0;
              const discount =
                data?.discountAmount ??
                item?.receiptId?.discountPrice ??
                item?.discountAmount ??
                0;
              const balanceDue =
                typeof dueFromReceipt === "number"
                  ? dueFromReceipt
                  : computedTotal - paidAmount - discount;

              return (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Sl No</th>
                        <th>Item Name</th>
                        <th>Rate</th>
                        <th>Tax</th>
                        <th>SGST</th>
                        <th>CGST</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                  </table>
                  <div className={styles["amountsSection"]}>
                    <div className={styles["amountRow"]}>
                      <span className={styles["label"]}>Total Amount</span>
                      <span className={styles["value"]}>
                        Rs {computedTotal.toFixed(2)}
                      </span>
                    </div>
                    <div className={styles["amountRow"]}>
                      <span className={styles["label"]}>Discount</span>
                      <span className={styles["value"]}>
                        Rs {Number(discount || 0).toFixed(2)}
                      </span>
                    </div>
                    <div className={styles["amountRow"]}>
                      <span className={styles["label"]}>Paid Amount</span>
                      <span className={styles["value"]}>
                        Rs {Number(paidAmount || 0).toFixed(2)}
                      </span>
                    </div>
                    <div className={styles["amountRow"]}>
                      <span className={styles["label"]}>Balance Due</span>
                      <span className={styles["value"]}>
                        Rs {Number(balanceDue || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </>
              );
            }

            return (
              <table>
                <thead>
                  <tr>
                    <th>Test Name</th>
                    <th>Result</th>
                    <th>Unit</th>
                    <th>Bio. Ref. Interval</th>
                    <th>Method</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{data?.serviceName || "N/A"}</td>
                    <td>{data?.totalAmount || "-"}</td>
                    <td>{item?.unit || "INR"}</td>
                    <td>
                      {data?.referralAmount
                        ? `Commission: ₹${data.referralAmount}`
                        : "-"}
                    </td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            );
          })()}
        </div>
        {/* <div className={styles["comment"]}>
          <p>Comment:</p>
          <p>Interpretation: HbA1c%</p>
        </div>
        <div className={styles["commentTable"]}>
          <table>
            <tr>
              <td>≤5.6</td>
              <td>Normal</td>
            </tr>
            <tr>
              <td>5.7-6.4</td>
              <td>
                <b>At Risk For Diabetes</b>
              </td>
            </tr>
            <tr>
              <td>≥6.5</td>
              <td>
                <b>Diabetes</b>
              </td>
            </tr>
          </table>
          <p>Adapted from American Diabetes Association.</p>
          <div className={styles["commentOne"]}>
            <p className={styles["comments"]}>Comments:</p>
            <p>
              A 3 to 6 monthly monitoring is recommended in diabetics. People
              with diabetes should get the test done more often if their blood
              sugar stays too high or if their healthcare provider makes any
              change in the treatment plan. HbA1c concentration represent the
              integrated values for blood glucose over the preceding 8-12 weeks
              and is not affected by daily glucose fluctuation, exercise &
              recent food intake. Please note, Glycemic goal should be
              individualized based on duration of diabetes, age/life expectancy,
              comorbid conditions, known CVD or advanced microvascular
              complications, hypoglycemia unawareness, and individual patient
              considerations.
            </p>
          </div>
          <div className={styles["commentTwo"]}>
            <p className={styles["comments"]}>
              Factors that interfere with HbA1c Measurement:
            </p>
            <p>
              Hemoglobin variants, elevated fetal hemoglobin (HbF) and
              chemically modified derivatives of hemoglobin (e.g. carbamylated
              Hb in patients with renal failure) can affect the accuracy of
              HbA1c measurements.
            </p>
          </div>
          <div className={styles["commentThree"]}>
            <p className={styles["comments"]}>
              Factors that affect interpretation of HbA1c Measurement:
            </p>
            <p>
              Any condition that shortens erythrocyte survival or decrease mean
              erythrocyte age (e. g., recovery from acute blood loss, hemolytic
              anemia, HbSS, HbCC, and HbSC) will falsely lower HbA1c test
              results regardless of the assay method used. Iron deficiency
              anemia is associated with higher HbA1c.
            </p>
          </div>
        </div> */}
        <div className={styles["footerSection"]}>
          <div className={styles["footerSignature"]}>
            <div className={styles["footerqrcode"]}>
              <Image src={qrcode} alt="qrcode" {...safeImageProps} />
            </div>
            <div className={styles["signatureSection"]}>
              <img src={signature} alt="" {...safeImageProps} />
              <p className={styles["bold"]}>Signature</p>
              {/* <p className={styles["para"]}>MD DIAGNOSTICS</p> */}
            </div>
          </div>
          <div className={styles["footerLast"]}>
            {/* <p className={styles["labFacilities"]}>
              Registered office: Level 3 Vasant Square Mall, Pocket V, Sector B
              Vasant Kunj New Delhi 110070
            </p> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default TataReport;
